<script>
  import { getContext } from "svelte";
  import {
    activePlanet,
    showPopup,
    tip,
    progress,
    abouted,
  } from "../stores/global.js";
  import viewport from "../stores/viewport.js";
  import { fade } from "svelte/transition";

  const { shows } = getContext("App");

  let moved = false;

  const hideCheck = () => {
    if (showTip) moved = true;
  };

  $: show = shows.find((s) => s.index === $activePlanet);
  $: showTip = show && !$showPopup && $viewport >= 640;
  $: $progress, hideCheck();
  $: if (showTip) moved = false;
</script>

{#if show && !$showPopup && !moved && !$abouted}
  <p
    transition:fade="{{ duration: 100 }}"
    style="left: {$tip.x}px; top: {$tip.y}px;"
  >
    {show.titleHostless}
  </p>
{/if}

<style>
  p {
    position: absolute;
    z-index: var(--z-overlay);
    transform: translate(-50%, -50%);
    margin: 0;
    font-weight: bold;
    font-size: 14px;
    pointer-events: none;
    max-width: 15em;
    padding: 0.25em;
    text-align: center;
    text-shadow: 0 0 3px var(--base-black);
    white-space: nowrap;
  }
</style>
